class ExtraValueDescription {
  static toName = (id: string): string => {
    switch(id) {
      case 'standard_deviation': return "Standard deviation";
      case 'duplicate_analysis': return "Duplicate analysis";
      default: return "Unknown extra result value description";
    }
  }

  static getList = (): string[] => {
    return [
      'standard_deviation',
      'duplicate_analysis'
    ];
  }
}

export { ExtraValueDescription }